import { birthday, emptyBirthday } from "../../../model/birthday";

export interface IState {
    birthdays: Array<birthday>;
    selectedBirthday?: birthday;
    isLoadingBirthdays: boolean;
}

export const DefaultState = (): IState => ({
    birthdays: [],
    selectedBirthday: emptyBirthday(),
    isLoadingBirthdays: false,
})
